import TableWithLoadingWrapper from '../../generic/dataGrid'
import Typography from '@mui/material/Typography'
import { toPrice, commafy } from '../../../helpers/stringFormat'

const columns = [
  {
    field: 'description',
    headerName: 'Description',
    flex: 2,
    renderCell: (params) => {
      const { description } = params.row
      return <Typography variant='primary'>{description}</Typography>
    },
  },
  {
    field: 'quantity',
    headerName: 'Quantity',
    flex: 1,
    renderCell: (params) => {
      const { quantity } = params.row
      return <Typography variant='primary'>{commafy(quantity)}</Typography>
    },
  },
  {
    field: 'usd_market_value',
    headerName: 'Position Market Value',
    flex: 1,
    renderCell: (params) => {
      const { usd_market_value } = params.row
      return <Typography variant='primary'>{toPrice(usd_market_value)}</Typography>
    },
  },
]

const SftpPositions = ({ positionsData }) => {
  return <TableWithLoadingWrapper columns={columns} dataSource={positionsData} loading={false} />
}

export default SftpPositions
